const email = '/assets/norte/Home/envelope.svg';
const phone = '/assets/norte/Home/phone.svg';
const PopupIcon = '/assets/norte/gallery/gallery5.jpg';


const BookingActive = '/assets/norte/Home/searchbar-buy-ticket.svg';
const CancelActive = '/assets/norte/Home/searchbar-cancel-ticket.svg';

const BIA = '/assets/norte/Home/searchbar-buy-ticket-white.svg';
const CIA = '/assets/norte/Home/searchbar-cancel-ticket-white.svg';

const CancelTicketInactive = '/assets/norte/Home/Search bar-anular pasaje-blanco.svg';
const ComprarInacActiveImage = '/assets/norte/Home/Search bar-compra tu pasaje-blanco.svg';

const CuponeraActive = '/assets/norte/Home/searchbar-cuponera.svg';
const Cancel = '/assets/norte/Home/searchbar-cancel-ticket-white.svg';
const booking = '/assets/norte/Home/searchbar-buy-ticket-white.svg';
const ConfirmCuponeraActive = '/assets/norte/Home/Ivergrama-Website-Home-SearchBar-Confirm-Cuponera.svg';

const OriginIcon = '/assets/norte/Home/origin.svg';
const DestinationIcon = '/assets/norte/Home/destination.svg';
const TelephoneIcon = '/assets/norte/Home/telephone.png';
const VermapaIcon = '/assets/norte/Home/vermapa.png';
const CalendarIcon = '/assets/norte/Home/calendar.svg';
// const SearchIcon = '/assets/norte/Home/Ivergrama-Website-Home-SearchBar-SearchIcon.svg';
const titleUnderline = '/assets/norte/Home/underline.svg';

const sendBtn = '/assets/norte/Home/enviar.svg';
const contactFormImg = '/assets/norte/Home/special-services.png';

const fb = '/assets/norte/Home/facebook.svg';
const fbHover = '/assets/norte/Home/facebook.svg';
const ins = '/assets/norte/Home/instagram.svg';
const insHover = '/assets/norte/insta-hover.svg';
const footen = '/assets/norte/Home/whiteenv.svg';


const twitter = '/assets/norte/Home/instagram.svg';
const twitterHover =
	'/assets/norte/Home/instagram.svg';

const LocationIcon = '/assets/norte/general/LocationIcon.svg';
const PhoneIcon = '/assets/norte/Home/phone.svg';
const HeaderLogo = '/assets/norte/general/Header-BusesTepualLogo.svg';
const FooterLogo = '/assets/norte/general/Footer-BusesTepualLogo.svg';
const checkboxIcon = '/static/images/icons/BusOperatorsWebsite-Checkbox.png';
const BottomFooterKuposLogo = '/assets/common/Footer-kuposLogo.svg';
const animation = '/static/images/animations/Services-kupos-PasajeBus-Orange.gif';
const pnr = '/assets/norte/Home/where-to-find-my-pnr.svg';

const contactMail = '/assets/norte/Contact/Ivergrama-Website-Contact-EmailIcon.svg';
const contactAddress = '/assets/norte/Contact/Ivergrama-Website-Contact-LocationIcon.svg';
const busnorteContactMail = 'assets/norte/Home/correo.svg';
const busnorteContact = 'assets/norte/Home/Contact.svg';


const servicesBanner = '/assets/norte/Home/banner-conoce-nuestros-servicios.png';

const aboutUsImage = '/assets/norte/aboutUs/about-us-history-image.png';


const FleetTv = '/assets/norte/fleet/18.svg';
const FleetToilet = '/assets/norte/fleet/19.svg';
const FleetAc = '/assets/norte/fleet/20.svg';
const FleetBed = '/assets/norte/fleet/22.svg';
// banners
const destinationBanner = '/assets/norte/destinations/destination-main.jpg';
const serviceBanner = '/assets/norte/Services/Ivergrama-Website-Services-MainBanner.jpg';
const faqBanner = '/assets/norte/Home/Preguntas-frecuentes-banner.png';
const contactUsBanner = '/assets/norte/Contact/Header.png';
const aboutUsBanner = '/assets/norte/aboutUs/about-us-header.png';
const tncBanner = '/assets/norte/tnc/Ivergrama-Website-TermsAndConditions-MainBanner.jpg';
const officeBanner = '/assets/norte/offices/offices-banner.jpg';
const fleetBanner = '/assets/norte/fleet/fleet-banner.png';

const OfficePhoneIcon = '/assets/norte/general/officePhone.svg';

const success = '/assets/norte/Gray/MyAccount-IllustratedIcons-CheckMark-Gray.svg';
const failure = '/assets/norte/Gray/MyAccount-IllustratedIcons-Information-Gray.svg';

const tick = '/assets/norte/Gray/MyAccount-IllustratedIcons-Tick-Gray.svg';
const heartOn = '/assets/norte/Gray/MyAccount-IllustratedIcons-HeartOn-Gray.svg';
const heartOff = '/assets/norte/Gray/MyAccount-IllustratedIcons-HeartOff-Gray.svg';
const downArrow = '/assets/norte/Gray/MyAccount-IllustratedIcons-DropDown-Gray.svg';
const registrationSuccess =
	'/assets/norte/Gray/MyAccount-IllustratedIcons-RightDocument-Gray.svg';
const userIcon = '/assets/norte/Home/login.svg';
const trips = '/assets/norte/Gray/MyAccount-IllustratedIcons-MyTrips-Gray.svg';
const cards = '/assets/norte/Gray/MyAccount-IllustratedIcons-MyCards-Gray.svg';
const wallet = '/assets/norte/Gray/MyAccount-IllustratedIcons-RechargeWallet-Gray.svg';
const transaction = '/assets/norte/Gray/MyAccount-IllustratedIcons-ShareMoney-Gray.svg';
const otp = '/assets/norte/Gray/MyAccount-IllustratedIcons-RestorePassword-Gray.svg';

const paso_1 = '/assets/norte/Gray/MyAccount-IllustratedIcons-RechargeWallet-Gray.svg';
const paso_2 = '/assets/norte/Gray/MyAccount-IllustratedIcons-RechargePoints-Gray.svg';
const paso_3 = '/assets/norte/Gray/MyAccount-IllustratedIcons-ID-Gray.svg';
const paso_4 = '/assets/norte/Gray/MyAccount-IllustratedIcons-Tickets-Gray.svg';

//  pet seat
const petseatref =
	'/assets/norte/pet/Ivergrama-ResultPage-SeatPick-PetsOnBoard_Pet Paw Icon (Amenite).svg';
const petseatModal = '/assets/norte/pet/PopUp.png';
const petfilteroff = '/assets/norte/pet/Ivergrama-ResultPage-PetsOnBoard-Button-Filter_off.svg';
const petfilteron = '/assets/norte/pet/Ivergrama-ResultPage-PetsOnBoard-Button-Filter_On.svg';

// const operatorPay = '/assets/norte/iverpay.png';
const whiteDownArrow = 'assets/ivergrama/Home/Down-arrow.svg';
const tncDownArrow = 'assets/ivergrama/tnc/arrow-icon.svg';
const accordOpen = 'assets/centropuerto/Preguntas/P.frecuentes-active.png';
const accordClose = 'assets/centropuerto/Preguntas/P.frecuentes-inactive.png';


const norteIcons = [
	{ icon: downArrow, name: 'downArrow' },
	{ icon: tncDownArrow, name: 'tncDownArrow' },

	{ icon: whiteDownArrow, name: 'whiteDownArrow' },
	{ icon: accordOpen, name: 'accordOpen' },
	{ icon: accordClose, name: 'accordClose' },

	{ icon: userIcon, name: 'userIcon' },
	{ icon: trips, name: 'trips' },
	{ icon: cards, name: 'cards' },
	{ icon: wallet, name: 'wallet' },
	{ icon: transaction, name: 'transaction' },
	{ icon: success, name: 'success' },
	{ icon: failure, name: 'failure' },
	{ icon: tick, name: 'tick' },
	{ icon: heartOn, name: 'heartOn' },
	{ icon: heartOff, name: 'heartOff' },
	{ icon: registrationSuccess, name: 'registrationSuccess' },
	{ icon: otp, name: 'otp' },

	{ icon: paso_1, name: 'paso_1' },
	{ icon: paso_2, name: 'paso_2' },
	{ icon: paso_3, name: 'paso_3' },
	{ icon: paso_4, name: 'paso_4' },

	{ icon: PhoneIcon, name: 'phone' },
	{ icon: email, name: 'email' },
	{ icon: LocationIcon, name: 'location' },
	{ icon: HeaderLogo, name: 'headerLogo' },
	{ icon: FooterLogo, name: 'footerLogo' },
	{ icon: contactFormImg, name: 'contactFormImg' },
	{ icon: titleUnderline, name: 'titleUnderline' },

	{ icon: sendBtn, name: 'sendBtn' },
	{ icon: fb, name: 'fb' },
	{ icon: fbHover, name: 'fbHover' },
	{ icon: ins, name: 'ins' },
	{ icon: insHover, name: 'insHover' },

	{ icon: success, name: 'success' },
	{ icon: failure, name: 'failure' },
	{ icon: twitter, name: 'twitter' },
	{ icon: twitterHover, name: 'twitterHover' },

	{ icon: footen, name: 'footen' },
	{ icon: BookingActive, name: 'BA' },
	{ icon: CancelActive, name: 'CA' },
	{ icon: CuponeraActive, name: 'CUA' },
	{ icon: Cancel, name: 'cancel' },
	{ icon: booking, name: 'booking' },
	{ icon: ConfirmCuponeraActive, name: 'CCA' },

	{ icon: OriginIcon, name: 'Origin' },
	{ icon: DestinationIcon, name: 'Destination' },
	{ icon: TelephoneIcon, name: 'Telephone' },
	{ icon: VermapaIcon, name: 'Vermapa' },
	{ icon: CalendarIcon, name: 'Calendar' },
	// { icon: SearchIcon, name: 'Search' },
	{ icon: PopupIcon, name: 'Popup' },
	{ icon: checkboxIcon, name: 'Checkbox' },
	{ icon: BottomFooterKuposLogo, name: 'BottomFooterKuposLogo' },
	{ icon: animation, name: 'animation' },
	{ icon: pnr, name: 'pnr' },
	{ icon: OfficePhoneIcon, name: 'OfficePhoneIcon' },

	{ icon: contactMail, name: 'contactMail' },
	{ icon: busnorteContactMail, name: 'busnorteContactMail' },
	{ icon: busnorteContact, name: 'busnorteContact' },
	{ icon: contactAddress, name: 'contactAddress' },
	{ icon: destinationBanner, name: 'destinationBanner' },
	{ icon: faqBanner, name: 'faqBanner' },
	{ icon: serviceBanner, name: 'serviceBanner' },
	{ icon: contactUsBanner, name: 'contactUsBanner' },
	{ icon: aboutUsImage, name: 'aboutUsImage' },
	{ icon: aboutUsBanner, name: 'aboutUsBanner' },
	{ icon: tncBanner, name: 'tncBanner' },
	{ icon: officeBanner, name: 'officeBanner' },
	{ icon: fleetBanner, name: 'fleetBanner' },


	{ icon: FleetTv, name: 'FleetTv' },
	{ icon: FleetToilet, name: 'FleetToilet' },
	{ icon: FleetAc, name: 'FleetAc' },
	{ icon: FleetBed, name: 'FleetBed' },

	//  pet seat
	{ icon: petseatref, name: 'petseatref' },
	{ icon: petseatModal, name: 'petseatModal' },
	{ icon: petfilteron, name: 'petfilteron' },
	{ icon: petfilteroff, name: 'petfilteroff' },
	// { icon: operatorPay, name: 'operatorPay' },
	{ icon: CIA, name: 'CIA' },
	{ icon: BIA, name: 'BIA' },
	{ icon: CancelTicketInactive, name: 'CancelTicketInactive' },
	{ icon: ComprarInacActiveImage, name: 'ComprarInacActiveImage' },
	{ icon: servicesBanner, name: 'servicesBanner' },
];

export default norteIcons;



// WEBPACK FOOTER //
// ./src/features/themes/functions/getIcons/norteIcons.js